/* AUTO-GENERATED from @tabby.ai/tabby-ui by scripts/sync-o26-typography.ts. Do not edit manually; run npm run typography:sync. */
export const TABBY_TEXT_FONT_FAMILY = 'Tabby Sans Text';
export const TABBY_DISPLAY_FONT_FAMILY = 'Tabby Sans Display';
